import { getAllFolderIdsLoadedInEventsCache } from '../../selectors/eventsCacheSelectors';
import { reloadCalendarEventsCache } from './reloadCalendarEventsCache';

export function reloadAllCalendarEventsCache() {
    const folderIds = getAllFolderIdsLoadedInEventsCache();

    folderIds.map(folderId => reloadCalendarEventsCache(folderId));
}
